export default "__VITE_ASSET__BUv9AnhY__"